<template>
  <div class="air-home-container">
    <div class="air-home-content">
      <!-- <router-view></router-view> -->
      <scenePage v-if="page === 'AirMonitorHomeScene'" />
      <devicePage v-else />
    </div>
    <div class="air-home-footer">
      <el-radio-group v-model="page" @change="switchPage">
        <el-radio-button label="AirMonitorHomeScene">{{ $t('场景图') }}</el-radio-button>
        <el-radio-button label="AirMonitorHomeDevice">{{ $t('设备图') }}</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import scenePage from '@/views/air-monitor/home/scene.vue';
import devicePage from '@/views/air-monitor/home/device.vue';

export default {
  data() {
    return {
      page: ''
    };
  },
  components: {
    scenePage,
    devicePage
  },
  mounted() {
    this.page = sessionStorage.getItem('air-monitor-page-tag') || 'AirMonitorHomeScene';
  },
  beforDestroy() {
    sessionStorage.removeItem('air-monitor-page-tag');
  },
  methods: {
    switchPage(val) {
      sessionStorage.setItem('air-monitor-page-tag', val);
      this.page = val;
    }
  }
};
</script>

<style lang="scss">
.air-home-container {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .air-home-content {
    width: 100%;
    height: 100%;
  }

  .air-home-footer {
    width: 100%;
    height: 67px;

    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, 0);

    display: flex;
    justify-content: center;
    align-items: center;

    .el-radio-group {
      border: 2px solid #047eba;
      border-radius: 40px;
      box-sizing: border-box;
      overflow: hidden;

      .el-radio-button {
        .el-radio-button__inner {
          color: var(--air-home-radio-button-color, #fff);
        }

        &.is-active {
          .el-radio-button__inner {
            border-radius: 50px;

            background-color: #047eba;
            border: 1px solid #047eba;
          }
        }
      }
    }
  }
}
</style>
